
function CheckVarizId(input) {
    var Result = "";
    var BillNumber = input.substring(0, input.length - 2).trim();
    var Temp = [
        14,
        13,
        12,
        11,
        10,
        9,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ];

    switch (BillNumber.length) {
        case 1:
            Result = "0000000000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select          
        case 2:
            Result = "000000000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 3:
            Result = "00000000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 4:
            Result = "0000000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 5:
            Result = "000000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 6:
            Result = "00000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 7:
            Result = "0000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 8:
            Result = "000000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 9:
            Result = "00000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 10:
            Result = "0000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 11:
            Result = "000" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        case 12:
            Result = "00" + BillNumber;
            break; // TODO: might not be correct. Was : Exit Select
        default:
            Result = "0" + BillNumber;
            break;
    }
    if (Result.length === 14) {
        let Sum = 0;
        var BillNumArray = Result.split('');
        for (var i = 0; i <= BillNumArray.length - 1; i++) {
            Sum += parseInt(BillNumArray[i].toString()) * Temp[i];
        }
        Result = "";
        var depositId = parseFloat(Sum) / parseFloat(99);
        var s = depositId.toString();
        /* eslint-disable */
        var a = s.split(/[ .:;?!~,`"&|()<>{}\[\]\r\n/\\]+/);
        if (a.length === 2) {
            s = a[1].substring(0);
        }
        else {
            s = "0";
        }
        switch (s.length) {
            case 1:
                Result = BillNumber + s + "0";
                break; // TODO: might not be correct. Was : Exit Select
            case 2:
                Result = BillNumber + s;
                break; // TODO: might not be correct. Was : Exit Select
            default:
                Result = BillNumber + s.substring(0, 2);
                break; // TODO: might not be correct. Was : Exit Select
        }

    }
    if (input === Result) { return true; }
    return false;
}

export default CheckVarizId